import { LitElement, html, utils } from '@hh/global.js'

class HHHeader extends LitElement {
  constructor() {
    super()

    this.doToggle = this.doToggle.bind(this)
    this.toggleSearchModal = this.toggleSearchModal.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    this.mobileMenuGroups = utils.all('.js-mobile-menu-group', this)
    this.mobileMenuGroups.forEach(element => {
      element.addEventListener('click', this.handleClickMobileMenuGroup.bind(this))
    })
    this.btnCloseSearch = utils.all('[data-close-search]')
    this.btnCloseSearch.forEach(btn => btn.addEventListener('click', this.toggleSearchModal))

    window.addEventListener('keyup', this.closeWithEsc.bind(this))
  }

  closeOpenModals(e) {
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.setAttribute('open', false)
      }
    })
  }

  toggleCart(e) {
    const selector = '.mini-cart'
    this.doToggle(e, selector)
    setTimeout(() => {
      if (utils.one(selector).getAttribute('open')) {
        utils.one('.mini-cart__close', utils.one(selector)).classList.add('focus-none')
        utils.one('.mini-cart__close', utils.one(selector)).focus()
      }
    }, 300)
  }

  toggleSearchModal(e) {
    const selector = 'hh-header-search'
    this.doToggle(e, selector, 'header-search--opened')
    setTimeout(() => {
      if (utils.one(selector).getAttribute('open')) {
        utils.one(selector)._setupFocusTrap()
        utils.one('.header-search__input').focus()
      }
    }, 300)
  }

  doToggle(e, selector, addtionalBodyClass = '') {
    e?.detail?.event?.preventDefault()

    if (utils.one(selector).getAttribute('open')) {
      this.closeCustomModal(selector, addtionalBodyClass)
    } else {
      this.openCustomModal(selector, addtionalBodyClass)
    }
  }

  openCustomModal(selector, addtionalBodyClass = '') {
    utils.one(selector).setAttribute('open', true)
    document.documentElement.classList.add('overflow-hidden')
    document.body.classList.add('overflow-hidden')
    if (addtionalBodyClass) {
      document.body.classList.add(addtionalBodyClass)
    }
  }

  closeCustomModal(selector, addtionalBodyClass = '') {
    utils.one(selector).removeAttribute('open')
    document.documentElement.classList.remove('overflow-hidden')
    document.body.classList.remove('overflow-hidden')
    if (addtionalBodyClass) {
      document.body.classList.remove(addtionalBodyClass)
    }
  }

  closeWithEsc(e) {
    if (e.code?.toUpperCase() === 'ESCAPE') {
      if (
        utils.one('.mini-cart').getAttribute('open') ||
        utils.one('hh-header-search').getAttribute('open')
      ) {
        this.closeCustomModal('.mini-cart')
        this.closeCustomModal('hh-header-search', 'header-search--opened')
      }
    }
  }

  handleClickMobileMenuGroup(e) {
    const parent_details = e.target.closest('details') || null
    if (parent_details) {
      const is_open = parent_details.hasAttribute('open')
      if (!is_open) {
        const parent_ul = parent_details.closest('.mobile-menu__menu') || null
        if (parent_ul) {
          utils.all('details', parent_ul).map(element => {
            if (element !== e.target) {
              element.removeAttribute('open')
            }
          })
        }
      }
    }
  }

  render() {
    return html`<slot
      @modalOpened="${this.closeOpenModals}"
      @toggleCart="${this.toggleCart}"
      @toggleSearchModal="${this.toggleSearchModal}"
    ></slot>`
  }
}

customElements.define('hh-header', HHHeader)
